import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const handleSysButton = async (
   method,
   action,
   messageId,
   instanceStepId,
   recipientId,
   comment = "",
) => {
   let body = {
      instanceStepId,
      recipientId,
      comment,
   };

   if (messageId && parseInt(messageId) != 0) {
      body.messageId = messageId;
   }
   return axios({
      method: "POST",
      url: `${hostCloud}/legacy/request`,
      headers: {
         Accept: "*/*",
      },
      data: {
         endpoint: action,
         httpMethod: method,
         isAuthenticated: true,
         body: JSON.stringify(body),
      },
   });
};

export const processStep = async (actionId, comment, stepId, selectedRecipient) => {
   const body = {
      actionId,
      comment,
   };

   if (stepId) {
      body.stepId = stepId;
   }
   if (selectedRecipient) {
      body.recipientId = selectedRecipient;
   }

   return axios({
      method: "POST",
      url: `${hostCloud}/legacy/request`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/tasks2/method/executeStepAction",
         httpMethod: "POST",
         isAuthenticated: true,
         body: body,
      },
   });
};
export const replanMessages = async (replanningSlot, from, to) => {
   // ReplanningSlot - "day", "week", "month"
   const url = `${hostCloud}/legacy/request`;
   const params = {
      ...(!from ? { replanningSlot } : { replanningSlot: replanningSlot, from, to }),
   };
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/messages/method/replanMessages`,
         httpMethod: "GET",
         isAuthenticated: true,
         parameters: JSON.stringify(params),
      },
   }).then((res) => {
      return res;
   });
};

export const getSuggestedDates = async (
   messageId,
   dueDate,
   dueTime,
   actionType,
   taskToFinishEstimation,
) => {
   const url = `${hostCloud}/legacy/request`;
   const params = {
      id: parseInt(messageId),
      dueDate,
      dueTime,
      actionType,
      taskToFinishEstimation: parseInt(taskToFinishEstimation),
   };
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/messages/method/getSuggestedDates`,
         httpMethod: "GET",
         isAuthenticated: true,
         parameters: JSON.stringify(params),
      },
   }).then((res) => {
      return res;
   });
};

export const getMessageStats = async (listId, profile) => {
   const url = `${hostCloud}/legacy/request`;
   const params = {
      profile,
      listId,
   };
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/messages/method/stats`,
         httpMethod: "GET",
         isAuthenticated: true,
         parameters: JSON.stringify(params),
      },
   }).then((res) => {
      return res;
   });
};
